import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../Contexts/Auth/AuthContext";

const Header = ({ toggleSidebar }) => {
  const imageStyles = {
    width: '30px',
    height: '30px',
  };

  const [profileOpen, setProfileOpen] = useState(false);

  const toggleProfileMenu = () => {
    setProfileOpen((prev) => !prev);
  };

  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  const logoutHandler = () => {
    localStorage.removeItem('linkedin-scheduler-token');
    window.location.href = "/login";
  };

  const editProfileHandler = () => {
    setProfileOpen(false);
    navigate('/panel/profile');
  };

  return (
    <header className="fixed top-0 left-0 right-0 w-full bg-gray-900 border-b border-gray-700 px-6 py-3 h-20">
     {/* <header className="fixed top-0 left-0 right-0 w-full bg-gray-900 border-b border-gray-700 px-6 py-3"> */}
      <div className="max-w-screen-xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <button onClick={toggleSidebar} className="text-white bg-gray-700 hover:bg-gray-600 px-3 py-1 rounded-md">
            ☰
          </button>
          {/* <h1 className="text-xl font-bold">Post Pro</h1> */}
          <h1 className="text-2xl font-bold text-blue flex items-center gap-2">
              <i class="text-2xl fa fa-paper-plane"></i>
              PostPro
            </h1>
        </div>

        <div className="relative">
          <button onClick={toggleProfileMenu} className="flex items-center gap-2 focus:outline-none">
            <img src= {authContext?.userInfo?.profile_pic || "https://img.icons8.com/ios-filled/50/ffffff/user.png"} alt="User" className="h-8 w-8 rounded-full" />
            <span className="text-white font-medium">{authContext?.userInfo?.first_name +
                " " +
                authContext?.userInfo?.last_name}</span>
          </button>
          {profileOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white text-black rounded-md shadow-lg z-50">
              <button onClick={editProfileHandler} className="block px-4 py-2 hover:bg-gray-100">Edit Profile</button>
              <button onClick={logoutHandler} className="block px-4 py-2 hover:bg-gray-100">Logout</button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;